import { initShaderProgram } from "../../../../SharedGL/Shader";

export class ViolationBarShader {
  // Vertex shader program
  private readonly vsSource = `
    attribute vec4 aVertexPosition;

    uniform mat4 uModelViewMatrix;
    uniform mat4 uProjectionMatrix;
    uniform float uYScale;
    uniform float uYOffset;
    uniform int uRowIndex;
    uniform vec4 uColor;

    varying lowp vec4 vColor;

    void main(void) {
      float newY = (aVertexPosition.y * uYScale) + uYOffset;
      vec4 position = vec4(aVertexPosition.x, newY, aVertexPosition.zw );
      gl_Position = uProjectionMatrix * uModelViewMatrix * position;
      gl_Position.x = aVertexPosition.x;
      
      vColor = uColor;

    }
  `;
  // Fragment shader program
  private readonly fsSource = `
    varying lowp vec4 vColor;

    void main(void) {
      gl_FragColor = vColor;
    }
  `;

  public readonly shaderProgram: WebGLProgram;

  constructor(gl: WebGLRenderingContext) {
    this.shaderProgram = initShaderProgram(gl, this.vsSource, this.fsSource);
  }
}
